var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMallette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4998,
    cy: 33.7498,
    r: 31.45,
    fill: "white",
    stroke: "#FF9703",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8128 21.2061C30.0999 21.2061 29.4162 21.4892 28.9121 21.9933C28.4081 22.4974 28.1249 23.1811 28.1249 23.894V24.79H21.853C21.1401 24.79 20.4564 25.0732 19.9523 25.5773C19.4482 26.0814 19.165 26.765 19.165 27.4779V41.8136C19.165 42.5265 19.4482 43.2102 19.9523 43.7143C20.4564 44.2184 21.1401 44.5016 21.853 44.5016H45.1485C45.8614 44.5016 46.5451 44.2184 47.0492 43.7143C47.5533 43.2102 47.8365 42.5265 47.8365 41.8136V27.4779C47.8365 26.765 47.5533 26.0814 47.0492 25.5773C46.5451 25.0732 45.8614 24.79 45.1485 24.79H38.8766V23.894C38.8766 23.1811 38.5935 22.4974 38.0894 21.9933C37.5853 21.4892 36.9016 21.2061 36.1887 21.2061H30.8128ZM30.8128 22.998H36.1887C36.4263 22.998 36.6542 23.0924 36.8223 23.2604C36.9903 23.4285 37.0847 23.6564 37.0847 23.894V24.79H29.9168V23.894C29.9168 23.6564 30.0112 23.4285 30.1793 23.2604C30.3473 23.0924 30.5752 22.998 30.8128 22.998ZM34.1925 35.3877L46.0445 32.2284V41.8136C46.0445 42.0513 45.9501 42.2792 45.7821 42.4472C45.614 42.6152 45.3861 42.7096 45.1485 42.7096H21.853C21.6154 42.7096 21.3875 42.6152 21.2194 42.4472C21.0514 42.2792 20.957 42.0513 20.957 41.8136V32.2266L32.8091 35.3877C33.2623 35.5084 33.7392 35.5084 34.1925 35.3877ZM21.853 26.5819H45.1485C45.3861 26.5819 45.614 26.6763 45.7821 26.8444C45.9501 27.0124 46.0445 27.2403 46.0445 27.4779V30.3737L33.7319 33.6566C33.5805 33.6971 33.421 33.6971 33.2696 33.6566L20.957 30.3737V27.4779C20.957 27.2403 21.0514 27.0124 21.2194 26.8444C21.3875 26.6763 21.6154 26.5819 21.853 26.5819Z",
    fill: "#FF9703"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6714,
    height: 28.6714,
    fill: "white",
    transform: "translate(19.165 19.4141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMallette);
export default __webpack_public_path__ + "static/media/Logo_mallette.d5fe56af52af7553177d62e1ce98a3c3.svg";
export { ForwardRef as ReactComponent };